import React, { useContext } from 'react'
import { Button, Typography } from "mobily-ui-library/lib";
import { useTranslation } from 'react-i18next';
import { GlobalContext } from '../../context/GlobalContext';
import FTTHRouter from '../../assets/FTTHRouter.svg';
import OrderDetails from '../../components/OrderDetails/OrderDetails';

import './RequestDetails.scss';
import { changeDateFormat } from '../../utils';

const win: any = window;

function RequestDetails() {
    const { t } = useTranslation();

    const { state, dispatch }: any = useContext(GlobalContext);
    const { rtl, lang, requestDetails } = state;
    
    const handleRequestDetails = () => {
        const status = requestDetails?.OrderStatus;
        if (status.toLowerCase() === 'pending payment') {

            const encodedEdata = {
                mo: requestDetails.MobilyOrderNumber,
                fn: requestDetails.FirstName,
                ln: requestDetails.FamilyName,
                id: requestDetails.NationalId,
                dob: requestDetails.BirthDate,
                ph: requestDetails.MobileNumber,
                em: requestDetails.EmailAddress,
                sna: requestDetails.ShortNationalAddress,
                re: requestDetails.Region,
                cy: requestDetails.City,
                dt: requestDetails.District,
                st: requestDetails.Street,
                bg: requestDetails.BuildingNumber,
                zc: requestDetails.ZIPcode,
                pT: requestDetails.PayType,
                rId: requestDetails.PaymentReferenceId,
                xId: requestDetails.CorrelationID
            }

            const encoded = window.btoa(encodeURIComponent(JSON.stringify(encodedEdata)))
            const paymentUrl = win['base_portal_url'] + win['payment_url'];
            const trackOrderUrl = win['base_portal_url'] + `${win['ftth_track_order_url']}?edata=${encoded}`;

            const url = `${paymentUrl}?refId=${requestDetails?.PaymentReferenceId}&xCoId=${requestDetails?.CorrelationID}&src=FTTH&oId=${requestDetails?.MobilyOrderNumber}&cId=${requestDetails.NationalId}&lang=${lang}&returnUrl=${trackOrderUrl}`
            window.location.href = url;
        }
    }

    const status = requestDetails?.OrderStatus.toLowerCase();
    const statusValue = status === 'cancelled' ? t('Request_Cancelled') : status === 'in-progress' ? t('Awaiting_delivery') : status === 'pending 50 requests' ? t('Pending_enough_req') : status === 'completed' ? t('Installation_Completed') : t(requestDetails?.OrderStatus);
    const stepNumber = status === 'cancelled' ? 0 : status === 'pending payment' || status === 'pending 50 requests' ? 1 : status === 'in-progress' ? 2 : 3;
    const statusArr = new Array(3).fill(0);

    const handleCancelBtn = () => {
        dispatch({ type: 'UPDATE_POPUP', payload: 'cancelReason'})
    }

    return (
        <main className='FTTH__ReqDetailsContainer'>
            <div className='DCS__Section '>
                <section className='DCS__HeadingSection'>
                    <img src={FTTHRouter} alt='success' />
                    <div className='DCS__Subheading'>
                        <Typography className='TO_title'>{t('Your_FTTH_Coverage_request_status')}</Typography>
                    </div>
                </section>

                <section className='DCS__ProgressSection align-items-center'>
                    <div className='gap-4 d-flex flex-column align-items-center'>
                        <div className='d-flex align-items-center mt-2'>
                            {statusArr.map((el: any, i: number) => {
                                return (
                                    <React.Fragment key={el + i}>
                                        <div className={`progress-ellipse ${i < stepNumber ? 'active' : ''}`}></div>
                                        {statusArr.length - 1 !== i && (
                                            <div className={`progress-line ${i < stepNumber - 1 ? 'active' : status === 'cancelled' ? 'mx-0' : 'mx-2'}`}></div>
                                        )}
                                    </React.Fragment>
                                )
                            })}
                        </div>
                        <div className='d-flex flex-column align-items-center DCS__status'>
                            <Typography rtl={rtl} className="status-text">{statusValue}</Typography>
                            {status !== 'cancelled' && (
                                <Typography rtl={rtl} className="status-value">
                                    {status === 'pending 50 requests' ? t('At_50_req') : status === 'completed' ? t('Completed_on') : t('Expected_delivery_on')}
                                    <span> {status === 'pending 50 requests' ? "" : status === 'completed' ? changeDateFormat(requestDetails?.CompletionDate) : ['in-progress', 'pending payment'].includes(status) ? changeDateFormat(requestDetails?.AwaitingDeliveryEndDate) : changeDateFormat(requestDetails?.RequestDate)} </span>
                                </Typography>
                            )}
                        </div>
                    </div>

                    {status === 'pending payment' && (
                        <div className='TD__Description d-flex flex-column gap-2'>
                            <Button
                                primary={true}
                                rtl={rtl}
                                variant={'default'}
                                htmlType={'submit'}
                                className='paynow-btn'
                                onClick={handleRequestDetails}
                            >
                                {t('PAY_NOW')}
                            </Button>
                            {/* <Typography rtl={rtl} className="status-value">{t('2000_SAR_one-time_setup_fee')}</Typography> */}
                        </div>
                    )}

                    {["B", "C"].includes(requestDetails?.ZoneCategory) && status === 'pending 50 requests' && (
                        <div className='TD__Description d-flex flex-column gap-2'>
                            <Button
                                primary={true}
                                rtl={rtl}
                                variant={'default'}
                                htmlType={'submit'}
                                className='cancel-btn'
                                onClick={handleCancelBtn}
                            >
                                {t('Cancel_Request')}
                            </Button>
                        </div>
                    )}
                </section>

                <OrderDetails status={status} />
            </div>
        </main>
    )
}

export default RequestDetails